module.exports = __webpack_public_path__ + "static/media/ss-shukla.dbc803fc.png";